import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import Loadable from './Loadable';
import PrivateRoute from './PrivateRoute';

// Lazy Imports
const TinSubmissionPage = Loadable(
  lazy(() => import('../pages/TinSubmissionPage')),
);

// Full-screen, authenticated compliance flows that render outside the main
// app layout (no sidebar).
const ComplianceRoutes: RouteObject = {
  path: '/app/tin',
  element: (
    <PrivateRoute>
      <TinSubmissionPage />
    </PrivateRoute>
  ),
};

export default ComplianceRoutes;
